<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_fabu">
            <div class="fabu_tit">
                <p>发布求购</p>
            </div>
            <!--..表单..-->
            <form v-loading="id > 0 && loading">
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>求购品类：</label>
                    <select name="side" v-model="model.category_id_1" style="width:133px" @change="getchildCategory(true)">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.category_id"  v-for="item in categoryList" :key="item.category_id">{{item.category_name}}</option>
                    </select>
                    <select name="side" v-model="model.category_id" style="width:133px" @change="getAttr(true)">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.category_id" v-for="item in childCategoryList" :key="item.category_id">{{item.category_name}}</option>
                    </select>
                    <select name="side" v-model="attr_value_id" style="width:133px" @change="test()">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.attr_value_id" v-for="item in attrList" :key="item.attr_value_id">{{item.attr_value_name}}</option>
                    </select>
                </p>
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>求购数量：</label>
                    <input type="text" v-model="model.number" placeholder='请输入求购数量' style="width:300px" maxlength="11" />
                    <select name="side" style="width:110px" v-model="model.unit">
                        <option :value="item.typename" v-for="item in units" :key="item.tid">{{item.typename}}</option>
                    </select>
                </p>
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>期望货源地：</label>
                    <select v-model="model.province_code" name="side" style="width:133px" @change="changeArea(2)">
                        <option value="" disabled style="display:none">请选择省</option>
                        <option :value="item.id" v-for="item in provinceList" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.city_code" name="side" style="width:133px" @change="changeArea(3)">
                        <option value="" disabled style="display:none">请选择市</option>
                        <option :value="item.id" v-for="item in cityList" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.district_code" name="side" style="width:133px">
                        <option value="" disabled style="display:none">请选择区/县</option>
                        <option :value="item.id" v-for="item in districtList" :key="item.id">{{item.shortname}}</option>
                    </select>
                </p>
                <p class="fabu_form_p01">
                    <!-- <label><span style="color:red">*</span>收货地址：</label><input type="text" v-model="model.address" placeholder='请输入收货地址' maxlength="30" /> -->
                    <label><span style="color:red">*</span>收货地：</label>
                    <select v-model="model.province_code_address" name="side" style="width:133px" @change="changeArea_address(2)">
                        <option value="" disabled style="display:none">请选择省</option>
                        <option :value="item.id" v-for="item in provinceList_address" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.city_code_address" name="side" style="width:133px" @change="changeArea_address(3)">
                        <option value="" disabled style="display:none">请选择市</option>
                        <option :value="item.id" v-for="item in cityList_address" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.district_code_address" name="side" style="width:133px">
                        <option value="" disabled style="display:none">请选择区/县</option>
                        <option :value="item.id" v-for="item in districtList_address" :key="item.id">{{item.shortname}}</option>
                    </select>
                </p>
                <!-- <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>手机号：</label><input type="text" v-model="model.tel" placeholder='请输入手机号' maxlength="11" />
                </p> -->
                <p class="fabu_form_p01">
                    <label>备注：</label><input type="text" v-model="model.remark" placeholder='请输入备注' maxlength="50" />
                </p>
                <!--...提交按钮..-->
                <a href="javascript:void(0)" v-if="id>0"><input type="button" id="" value="确认修改" @click="submit()" class="fabu_form_but" /></a>
                <a href="javascript:void(0)" v-else><input type="button" id="" value="确认发布" @click="submit()" class="fabu_form_but" /></a>
            </form>
        </div>
    </div>
</template>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import { publictypeList } from '@/api/publicType/publicType';
    import { getArea } from '@/api/address';
    import { getSelectList, getAttrValueList } from '@/api/goods/goodscategory';
    import { addPurchase, editPurchase, purchaseDetail } from '@/api/purchase/purchase';
    import util from '@/utils/util.js';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                id:0,
                model:{category_id_1:'', category_id:'', attr_value_id:'', province_code:'', city_code:'', district_code:'', province_code_address:'', city_code_address:'', district_code_address:''},
                attr_value_id:'',
                loading:true,
                units:[],
                provinceList:[],
                cityList:[],
                districtList:[],
                provinceList_address:[],
                cityList_address:[],
                districtList_address:[],
                categoryList:[],
                childCategoryList:[],
                attrList:[],
            }
        },
        created() {
            this.id = this.$route.query.id;
            if(this.id > 0) {
                this.getDetails();
            }
            this.getUnits();
            this.getAreas('', 1);
            this.getCategory();
        },
        methods: {
            getDetails() {
                purchaseDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        console.log(res.data);
                        this.attr_value_id = this.model.attr_value_id;
                        var list = this.model.category_path.split(',');
                        this.model.category_id_1 = list[1];
                        //期望货源地
                        var areapathlist = this.model.areapath.split(';');
                        var codelist = [];
                        areapathlist.forEach(item => {
                            if(!util.isEmpty(item)) {
                                codelist.push(item);
                            }
                        });
                        this.model.province_code = codelist[0];
                        this.model.city_code = !util.isEmpty(codelist[1]) ? codelist[1] : "";
                        this.model.district_code = !util.isEmpty(codelist[2]) ? codelist[2] : "";
                        //this.changeArea(2);
                        this.getAreas(this.model.province_code, 2);
                        if(codelist.length>1) {
                            //this.changeArea(3);
                            this.getAreas(this.model.city_code, 3);
                        }
                        if(codelist.length>2) {
                        }
                        //收货地址
                        var addresspathlist = this.model.address_path.split(';');
                        var addresslist = [];
                        addresspathlist.forEach(item => {
                            if(!util.isEmpty(item)) {
                                addresslist.push(item);
                            }
                        });
                        this.model.province_code_address = addresslist[0];
                        //this.changeArea_address(2);
                        this.getAreas_address(this.model.province_code_address, 2);
                        if(addresslist.length>1) {
                            this.model.city_code_address = addresslist[1];
                            //this.changeArea_address(3);
                            this.getAreas_address(this.model.city_code_address, 3);
                        }
                        if(addresslist.length>2) {
                            this.model.district_code_address = addresslist[2];
                        }

                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err);
                })
            },
            getUnits() {
                publictypeList({
                    typenumber: '10007',
                    level: 2
                }).then(res => {
                    if(res.code == 0) {
                        this.units = res.data;
                        if(this.units.length>0) {
                            this.model.unit = this.units[0].typename;
                        }
                    }
                })
            },
            getAreas(pid, level) {
                getArea({
                    pid: pid
                }).then(res => {
                    if(res.code == 0) {
                        switch(level)
                        {
                            case 1:
                                this.provinceList = res.data;
                                this.provinceList_address = res.data;
                                break;
                            case 2:
                                this.cityList = res.data;
                                break;
                            case 3:
                                this.districtList = res.data;
                                break;
                        }
                    }
                })
            },
            getAreas_address(pid, level) {
                getArea({
                    pid: pid
                }).then(res => {
                    if(res.code == 0) {
                        switch(level)
                        {
                            case 2:
                                this.cityList_address = res.data;
                                break;
                            case 3:
                                this.districtList_address = res.data;
                                break;
                        }
                    }
                })
            },
            changeArea(level) {
                if(level == 2) {
                    this.model.city_code = '';
                    this.model.district_code = '';
                    this.districtList = [];
                    if(!util.isEmpty(this.model.province_code))
                    {
                        this.getAreas(this.model.province_code, 2);
                    }
                }
                else {
                    this.model.district_code = '';
                    if(!util.isEmpty(this.model.city_code))
                    {
                        this.getAreas(this.model.city_code, 3);
                    }
                }
                
            },
            changeArea_address(level) {
                if(level == 2) {
                    this.model.city_code_address = '';
                    this.model.district_code_address = '';
                    this.districtList_address = [];
                    if(!util.isEmpty(this.model.province_code_address))
                    {
                        this.getAreas_address(this.model.province_code_address, 2);
                    }
                }
                else {
                    this.model.district_code_address = '';
                    if(!util.isEmpty(this.model.city_code_address))
                    {
                        this.getAreas_address(this.model.city_code_address, 3);
                    }
                }
                
            },
            getCategory() {
                getSelectList({
                    level:1
                }).then(res => {
                    if(res.code == 0) {
                        this.categoryList = res.data;
                        if(this.id>0) {
                            this.getchildCategory(false);
                            this.getAttr(false);
                        }
                    }
                });
            },
            getchildCategory(isclear) {
                this.attrList = [];
                if(isclear) {
                    this.model.category_id = '';
                }
                var _that = this;
                var list = this.categoryList.filter(function(item){
                    return item.category_id == _that.model.category_id_1;
                });
                if(list.length > 0 && !util.isEmpty(list[0].children)) {
                    this.childCategoryList = list[0].children;
                }
                else {
                    this.childCategoryList = [];
                }
            },
            getAttr(isclear) {
                if(isclear) {
                    this.model.attr_value_id = '';
                }
                var _that = this;
                var list = this.childCategoryList.filter(function(item){
                    return item.category_id == _that.model.category_id;
                });
                if(list.length > 0) {
                    getAttrValueList({
                        attr_class_id: list[0].attr_class_id
                    }).then(res => {
                        if(res.code == 0) {
                            this.attrList = res.data;
                        }
                    })
                }
            },
            test() {
                this.model.attr_value_id = this.attr_value_id;
            },
            submit() {
                if(util.isEmpty(this.model.category_id)) {
                    this.$message.warning("请选择求购品类！");
                    return;
                }
                if(util.isEmpty(this.model.number)) {
                    this.$message.warning("请填写求购数量！");
                    return;
                }
                var reg = /(^[0-9]{1,8}$)|(^[0-9]{1,8}[\\.]{1}[0-9]{1,2}$)/;
                if(!reg.test(this.model.number)) {
                    this.$message.warning("求购数量请填写小数点前最多8位，小数点后最多2位的数字！");
                    return;
                }
                if(util.isEmpty(this.model.unit)) {
                    this.$message.warning("请选择数量单位！");
                    return;
                }
                if(util.isEmpty(this.model.province_code)) {
                    this.$message.warning("请选择期望货源地！");
                    return;
                }
                if(util.isEmpty(this.model.district_code_address)) {
                    this.$message.warning("请选择收货地址！");
                    return;
                }
                // if(util.isEmpty(this.model.tel)) {
                //     this.$message.warning("请填写手机号！");
                //     return;
                // }
                // var telreg = /^1[3456789]\d{9}$/;
                // if(!telreg.test(this.model.tel)) {
                //     this.$message.warning("手机号格式不正确！");
                //     return;
                // }
                var areacode = this.model.province_code;
                var areapath = ';' + this.model.province_code + ';';
                if(!util.isEmpty(this.model.city_code)) {
                    areacode = this.model.city_code;
                    areapath += this.model.city_code + ';';
                }
                if(!util.isEmpty(this.model.district_code)) {
                    areacode = this.model.district_code;
                    areapath += this.model.district_code + ';';
                }

                var address_path = ';' + this.model.province_code_address + ';' + this.model.city_code_address + ';' + this.model.district_code_address + ';';
         
                var params = {
                   category_id: this.model.category_id,
                   attr_value_id: this.model.attr_value_id,
                   number: this.model.number,
                   unit: this.model.unit,
                   areacode: areacode,
                   areapath: areapath,
                   //tel: this.model.tel,
                   address_path: address_path,
                   remark: this.model.remark
                };
                if(this.id>0) {
                    params.id = this.id;
                    editPurchase(params).then(res => {
                        if(res.code == 0) {
                            this.$message.success("提交成功！");
                            location.href="/member/my_purchase";
                        }
                        else {
                            this.$message.error("提交失败,请重试！");
                        }
                    });
                }
                else {
                    addPurchase(params).then(res => {
                        if(res.code == 0) {
                            this.$message.success("提交成功！");
                            location.href="/member/my_purchase";
                        }
                        else {
                            this.$message.error("提交失败,请重试！");
                        }
                    });
                }
            }
        },
        mounted() {

		},
    }
</script>